import React, { FunctionComponent } from 'react';

import { $VerticalOneColumnLayout } from './VerticalOneColumnLayout.styles';
import { DENSITY, Density } from './VerticalOneColumnLayout.types';

interface VerticalOneColumnLayoutProps
  extends React.ComponentPropsWithRef<'div'> {
  density?: Density;
  isFluid?: boolean;
}

export const VerticalOneColumnLayout: FunctionComponent<
  React.PropsWithChildren<VerticalOneColumnLayoutProps>
> = ({ children, density = DENSITY.COMPACT, isFluid = true, ref, ...rest }) => {
  return (
    <$VerticalOneColumnLayout
      ref={ref}
      data-density={density}
      $isFluid={isFluid}
      {...rest}
    >
      {children}
    </$VerticalOneColumnLayout>
  );
};
